<template>
  <div>
    <section>
      <el-row>
        <el-col :span="1"> 
             <img class="avatar" :src="avatar?avatar:require('../../assets/avatar.png')"/>
        </el-col>
        <el-col :span="4">
            <el-col :span="24" >
                <el-form :inline="true">
                  <el-form-item  style="margin-bottom: -5px;">
                    <span style="font-size: 25px;">{{ shopName }}</span>
                  </el-form-item>
                </el-form>
            </el-col>
            <el-col :span="24">
                <el-form :inline="true">
                  <el-form-item >
                    <span style="font-size: 16px;color: #848181;">用户ID:</span>
                    <span style="font-size: 16px;color: #848181;">{{ merchantId }}</span>
                  </el-form-item>
                </el-form>
            </el-col>
        </el-col>
        <el-col :span="17" style="height:1px">
        </el-col>
        <el-col :span="2">
            <el-col :span="24" >
                <el-form :inline="true">
                  <el-form-item  style="margin-bottom: -5px;">
                     <span style="font-size: 16px;color: #848181;">员工数</span>
                  </el-form-item>
                </el-form>
            </el-col>
            <el-col :span="24">
                <el-form :inline="true">
                  <el-form-item >
                    <span style="font-size: 28px;">{{ staffNum }}人</span>
                  </el-form-item>
                </el-form>
            </el-col>
        </el-col>
      </el-row>
      <el-col :span="24" class="toolbar" style="padding-bottom: 5px">
        <el-form :inline="true">
          <el-form-item class="form-class">
            <el-input v-model="userName" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item class="form-class">
            <el-button type="primary" v-on:click="getFilterList">查询</el-button>
          </el-form-item >
          <el-form-item class="form-class">
            <el-button type="default" >重置</el-button>
          </el-form-item >
        </el-form>
      </el-col>
      <el-table stripe align="left" :data="tableData" highlight-current-row v-loading="listLoading"
                style="width: 100%;">
        <el-table-column align="center" label="邀请时间" min-width="15%">
          <template slot-scope="scope">
            <span>{{scope.row.createTime}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="userId" label="ID" min-width="10%"></el-table-column>
        <el-table-column align="center" prop="nickname" label="登录名" min-width="20%"></el-table-column>
        <el-table-column align="center" prop="staffName" label="备注" min-width="20%"></el-table-column>
        <el-table-column align="center" prop="checkCoupon" label="卡券核销" :formatter="formatCheckCoupon" min-width="20%"></el-table-column>
        <el-table-column align="center" prop="lookCoupon" label="查看卡券库、核销记录" :formatter="formatLookCoupon" min-width="20%"></el-table-column>
        <el-table-column align="center" prop="manageCoupon" label="创建、管理卡券" :formatter="formatManageCoupon" min-width="20%"></el-table-column>
        <el-table-column align="center" prop="manageStaff" label="员工管理" :formatter="formatManageStaff" min-width="20%"></el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page=currentPage
        :page-sizes="[10, 20, 30, 40]"
        :page-size=pageSize
        layout="total, sizes, prev, pager, next, jumper"
        :total=totalNumber>
      </el-pagination>
      <Dialog v-if="isShow" :propsData="propsData" @child-ok="childok" @child-cancel="childcancel"></Dialog>
    </section>
  </div>
</template>

<script>
  import {CouponOptions} from '../../views/details/detail-data.js'
  import Dialog  from '../../views/coupon/couponDetail.vue'
  export default {
    name: "coupon",
    components: {
      Dialog
    },
    data() {
      return {
        isShow:false,
        values: [],
        options: CouponOptions.data,
        tableDate: null,
        listLoading: false,
        staffNum: 0,
        userId: null,
        shopName: '',
        avatar:null,
        currentPage: 0,
        pageSize: 10,
        totalNumber: 0,
        timeInterval: '',
        AuthenStatuss:[{ label: '认证', value: '1' }, { label: '', value: '0' }],
        propsData:{},
        couponNum:0,
        couponName:'',
        tableData:[],
        merchantId:null,
        userName:'',
      }
    },

    methods: {
      formatCheckCoupon(row, column){
        let temp = this.AuthenStatuss.filter((item) => {
					return item.value == row.checkCoupon;
				})
				return temp[0].label;
      },
      formatManageCoupon(row, column){
        let temp = this.AuthenStatuss.filter((item) => {
					return item.value == row.manageCoupon;
				})
				return temp[0].label;
      },
      formatLookCoupon(row, column){
        let temp = this.AuthenStatuss.filter((item) => {
					return item.value == row.lookCoupon;
				})
				return temp[0].label;
      },
      formatManageStaff(row, column){
        let temp = this.AuthenStatuss.filter((item) => {
					return item.value == row.manageStaff;
				})
				return temp[0].label;
      },
      getFilterList() {
				this.currentPage = 1;
				this.getList(this.currentPage);
			},
      handleSizeChange(val) {
				this.pageSize = val;
				this.currentPage = 1;
				this.getList(this.currentPage);
      },
      handleCurrentChange(val) {
				this.currentPage = val;
				this.getList(this.currentPage);
      },
      async getList(index) {
				let condition = {}
				condition.userName = this.userName;
        condition.merchantId =this.merchantId;
        condition.currentPage = index;
        condition.pageSize =this.pageSize;
				try{
					this.listLoading = true;
					let result = await this.$http.post(this,'/merchant/getMerchantStaffList', {},condition);
					if (result && result.code == 200) {
            
						this.tableData = result.data.rows;
						this.totalNumber = result.data.total;
						this.listLoading = false;
					}
				} catch(e){
					this.listLoading = false;
				}
			},
      handleCouponDetail(index,row){
        this.propsData ={};
        this.propsData.userId =  this.userId;
        this.propsData.couponId = row.id;
        //this.$router.push({ path: '/operateManage/details', query: { userId: row.id,userName: row.nickName } });
      }
    },
    created() {
      this.merchantId = this.$route.query.merchantId;
      this.userId = this.$route.query.userId;
      this.shopName = this.$route.query.shopName;
      this.avatar = this.$route.query.avatar;
      this.staffNum = this.$route.query.staffNum;
      this.listLoading = true
      this.getList(0);
    }
  }
</script>

<style scoped>

  .toolbar {
    background: #f2f2f2;
    padding: 10px;
    margin: 10px 0px;
  }

  .icon-class {
    font-size: 30px;
    position: relative;
    vertical-align: sub;
    margin-left: 15px;
  }

  .form-class {
    margin-left: 1%;
  }

  .avatar{
    width: 60px;
    height: 60px;
    border-radius: 40px;
}
</style>
